import { useState } from "react";
import { Link } from "react-router-dom";
import { clienteApi } from "@/lib/api";
import { toast } from "sonner";
import { ArrowLeft, MailCheck } from "lucide-react";

export default function EsqueciSenha() {
  const [email, setEmail] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const enviar = async (e) => {
    e.preventDefault();
    setEnviando(true);
    try {
      await clienteApi.post("/cliente-auth/esqueci-senha", { email: email.trim().toLowerCase() });
      setEnviado(true);
    } catch {
      toast.error("Não foi possível enviar. Tente novamente.");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bbh-card p-6 sm:p-8" data-testid="esqueci-senha-page">
        <Link to="/portal/login" className="inline-flex items-center gap-1 text-xs text-zinc-500 hover:text-zinc-800 mb-4">
          <ArrowLeft className="w-3 h-3" /> Voltar ao login
        </Link>
        {enviado ? (
          <div className="text-center py-6">
            <div className="w-14 h-14 mx-auto rounded-full bg-emerald-100 flex items-center justify-center mb-4">
              <MailCheck className="w-7 h-7 text-emerald-600" />
            </div>
            <h1 className="font-heading text-2xl font-bold mb-2">Verifique seu e-mail</h1>
            <p className="text-sm text-zinc-600 mb-6">
              Se este e-mail estiver cadastrado no portal, você receberá em instantes um link para redefinir sua senha. O link expira em 1 hora.
            </p>
            <Link
              to="/portal/login"
              data-testid="voltar-login-btn"
              className="inline-block w-full text-center px-4 py-2.5 rounded-md bbh-btn-primary text-sm font-semibold"
            >
              Voltar ao login
            </Link>
          </div>
        ) : (
          <>
            <div className="text-[11px] font-semibold uppercase tracking-widest text-zinc-500 mb-1">
              Portal do cliente
            </div>
            <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight mb-1">Esqueci minha senha</h1>
            <p className="text-sm text-zinc-600 mb-6">
              Informe seu e-mail e enviaremos um link para redefinir sua senha.
            </p>
            <form onSubmit={enviar} className="space-y-4" data-testid="esqueci-senha-form">
              <div>
                <label className="text-[10px] font-semibold uppercase tracking-widest text-zinc-500">E-mail</label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="esqueci-senha-email"
                  autoComplete="email"
                  className="mt-1 w-full px-3 py-2.5 rounded-md border border-zinc-200 bbh-input text-sm"
                  placeholder="seu@email.com"
                />
              </div>
              <button
                type="submit"
                disabled={enviando}
                data-testid="esqueci-senha-submit"
                className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-md bbh-btn-primary text-sm font-semibold disabled:opacity-50"
              >
                {enviando ? "Enviando…" : "Enviar link de redefinição"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
